// Swiper
import './swiper.js';

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Modal } from '@daypilot/modal';
gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.Modal = Modal;

// Favorites
import { dyanne_platformFavorite } from './favorite';

// Save
import { dyanne_platformSave } from './save';

// Shop
import {
	dyanne_platformShopPagination,
	dyanne_platformFilterProducts,
	dyanne_platformPositionCallToActions,
	dyanne_platformPositionCallToActionsInit,
	dyanne_platformInitFilterProducts,
	dyanne_platformObserveCheckout,
	dyanne_platformFetchCartCount,
	dyanne_platformShopLoopSwiper,
	dyanne_platformRetrieveCartFromSession,
	dyanne_platformHandleCartRemovals,
} from './shop';

// Product
import {
	dyanne_platformInitProductGallerySwiper,
	dyanne_platformInitRelatedProductsSwiper,
	dyanne_platformSyncVariationDropdown,
	dyanne_platformAddToCart,
	dyanne_platformMarquee
} from './product';

// Instock notifier
import {
	dyanne_platformToggleInstocknotifierForm,
	dyanne_platformSubscribeInstocknotifier
} from './instocknotifier.js';

// Scroll text
import { dyanne_platformScrollText } from './scroll-text';

// Navigation
import { dyanne_platformNavigation } from './navigation';

// Account
import { dyanne_platformAccountUserCheck } from './account';

// Workshops
import { dyannePlatformWorkshopCalculator } from './workshops';

// Alpine
import './alpine.js';


document.addEventListener(
	'DOMContentLoaded',
	() => {
		// Navigation
		dyanne_platformNavigation();
		dyanne_platformPositionCallToActionsInit();
		dyanne_platformInitFilterProducts();
		dyanne_platformHandleCartRemovals();

		// Observer.
		dyanne_platformObserveCheckout();

		// Account.
		dyanne_platformAccountUserCheck();

		// Store scrollbar width in CSS variable.
		document.body.style.setProperty('--scrollbar-width', ( window.innerWidth - document.documentElement.clientWidth ) + 'px');
	},
	{ passive: true }
);

jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
	// Workshops totals calculator.
	dyannePlatformWorkshopCalculator( form_id);
});

window.addEventListener(
	'resize',
	() => {
		// Store scrollbar width in CSS variable.
		document.body.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');
	},
	{ passive: true }
);

window.dyanne_platformFavorite = dyanne_platformFavorite;
window.dyanne_platformSave = dyanne_platformSave;
window.dyanne_platformShopPagination = dyanne_platformShopPagination;
window.dyanne_platformFilterProducts = dyanne_platformFilterProducts;
window.dyanne_platformPositionCallToActions = dyanne_platformPositionCallToActions;
window.dyanne_platformScrollText = dyanne_platformScrollText;
window.dyanne_platformInitFilterProducts = dyanne_platformInitFilterProducts;
window.dyanne_platformInitProductGallerySwiper = dyanne_platformInitProductGallerySwiper;
window.dyanne_platformSyncVariationDropdown = dyanne_platformSyncVariationDropdown;
window.dyanne_platformMarquee = dyanne_platformMarquee;
window.dyanne_platformInitRelatedProductsSwiper = dyanne_platformInitRelatedProductsSwiper;
window.dyanne_platformAddToCart = dyanne_platformAddToCart;
window.dyanne_platformToggleInstocknotifierForm = dyanne_platformToggleInstocknotifierForm;
window.dyanne_platformSubscribeInstocknotifier = dyanne_platformSubscribeInstocknotifier;
window.dyannePlatformWorkshopCalculator = dyannePlatformWorkshopCalculator;
window.dyanne_platformFetchCartCount = dyanne_platformFetchCartCount;
window.dyanne_platformShopLoopSwiper = dyanne_platformShopLoopSwiper;
window.dyanne_platformRetrieveCartFromSession = dyanne_platformRetrieveCartFromSession;
window.dyanne_platformHandleCartRemovals = dyanne_platformHandleCartRemovals;
